import React from 'react';
import defaultStyle from './index.module.scss';
import errorIcon from '../../../assets/error-icon.svg';
import cancelIcon from '../../../assets/cancel.svg';

interface Props {
  errorMessages?: string;
  setCloseTooltip: Function;
}

const ErrorTooltip = ({ errorMessages, setCloseTooltip }: Props) => {

  const oncloseTooltip = () => {
    setCloseTooltip(true);
  };

  return (
    <div className={defaultStyle.container}>
      <div className={defaultStyle.details}>
        <img
          src={errorIcon}
          alt={'errorIcon'}
          style={{ width: '24px', height: '24px', padding: '22px 10px 0 10px' }}
        />
        <div style={{ paddingTop: '10px' }}>{errorMessages}</div>
        <img
          src={cancelIcon}
          alt={'cancelIcon'}
          style={{
            width: '24px',
            height: '24px',
            padding: '22px 10px 0 10px',
            cursor: 'pointer'
          }}
          onClick={oncloseTooltip}
        />
      </div>
    </div>
  );
};

export default ErrorTooltip;
